/* @flow */
import React, { Component } from 'react';

import { copyProperties } from '../../utils';
import MediaQueries from '../constants/MediaQueries';

export default function<P>(WrappedComponent: React.ComponentType<P>) {
  const component = WrappedComponent;
  // let ComposedComponent = component;

  class Breakpoint extends Component<
    { componentRef?: any },
    { breakpoint: BreakpointSize, verticalBreakpoint: VerticalBreakpointSize, retina: boolean }
  > {
    breaks: {
      small: Object,
      medium: Object,
      large: Object,
      xlarge: Object,
      tall: Object,
      retina: Object,
    };

    constructor() {
      super();

      this.breaks = {
        small: window.matchMedia(MediaQueries.js(MediaQueries.SmallCapped)),
        medium: window.matchMedia(MediaQueries.js(MediaQueries.MediumCapped)),
        large: window.matchMedia(MediaQueries.js(MediaQueries.LargeCapped)),
        xlarge: window.matchMedia(MediaQueries.js(MediaQueries.XLarge)),
        tall: window.matchMedia(MediaQueries.js(MediaQueries.Tall)),
        retina: window.matchMedia(MediaQueries.js(MediaQueries.Retina)),
      };

      let { small, medium, large, xlarge, tall, retina } = this.breaks;

      let verticalBreakpoint;
      if (tall.matches) {
        verticalBreakpoint = 'tall';
      } else {
        verticalBreakpoint = 'short';
      }

      if (xlarge.matches) {
        this.state = { breakpoint: 'xlarge', verticalBreakpoint, retina: retina.matches };
      } else if (large.matches) {
        this.state = { breakpoint: 'large', verticalBreakpoint, retina: retina.matches };
      } else if (medium.matches) {
        this.state = { breakpoint: 'medium', verticalBreakpoint, retina: retina.matches };
      } else if (small.matches) {
        this.state = { breakpoint: 'small', verticalBreakpoint, retina: retina.matches };
      } else {
        this.state = { breakpoint: 'small', verticalBreakpoint, retina: retina.matches };
      }

      small.addListener(this.onSmallMediaChange);
      medium.addListener(this.onMediumMediaChange);
      large.addListener(this.onLargeMediaChange);
      xlarge.addListener(this.onXLargeMediaChange);
      tall.addListener(this.onTallMediaChange);
      retina.addListener(this.onRetinaMediaChange);
    }

    onSmallMediaChange = (media: Object) => {
      if (media.matches) {
        this.setState({ breakpoint: 'small' });
      }
    };

    onMediumMediaChange = (media: Object) => {
      if (media.matches) {
        this.setState({ breakpoint: 'medium' });
      }
    };

    onLargeMediaChange = (media: Object) => {
      if (media.matches) {
        this.setState({ breakpoint: 'large' });
      }
    };

    onXLargeMediaChange = (media: Object) => {
      if (media.matches) {
        this.setState({ breakpoint: 'xlarge' });
      }
    };

    onTallMediaChange = (media: Object) => {
      if (media.matches) {
        this.setState({ verticalBreakpoint: 'tall' });
      } else {
        this.setState({ verticalBreakpoint: 'short' });
      }
    };

    onRetinaMediaChange = (media: Object) => {
      this.setState({ retina: media.matches });
    };

    componentWillUnmount() {
      let { small, medium, large, xlarge, tall, retina } = this.breaks;

      small.removeListener(this.onSmallMediaChange);
      medium.removeListener(this.onMediumMediaChange);
      large.removeListener(this.onLargeMediaChange);
      xlarge.removeListener(this.onXLargeMediaChange);
      tall.removeListener(this.onTallMediaChange);
      retina.removeListener(this.onRetinaMediaChange);
    }

    render() {
      let { componentRef, ...props } = this.props;
      let { breakpoint, retina, verticalBreakpoint } = this.state;
      return (
        <WrappedComponent
          ref={componentRef}
          breakpoint={breakpoint}
          verticalBreakpoint={verticalBreakpoint}
          retina={retina}
          {...props}
        />
      );
    }
  }

  // Class inheritance uses Object.create and because of __proto__ issues
  // with IE <10 any static properties of the superclass aren't inherited and
  // so need to be manually populated.
  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
  copyProperties(component, Breakpoint);

  return Breakpoint;
}



// WEBPACK FOOTER //
// ./src/ui/components/withBreakpoint.js